module.exports = __webpack_public_path__ + "static/media/studio-4.e064d090.jpg";